<template>
  <div>
    <div class="container flexCol">
      <div class="staticPage c-pages">
        <h1 class="staticPage-title">{{ title }}</h1>
        <div class="staticPage-content" v-html="html" />
      </div>
      <breadcrumbs :options="breadcrumbOptions" page="staticPage" display-mode="footer" class="breadcrumbsFooter" />
    </div>
  </div>
</template>

<script>
const Breadcrumbs = defineAsyncComponent(() => import('@/components/Breadcrumbs.vue'))
import { useMainStore } from '@/store'
import { callWithNuxt } from 'nuxt/app'

const NOT_FOUND_PAGE_SLUG = '404'

export default {
  components: { Breadcrumbs },
  setup() {
    const app = useNuxtApp()
    const store = useMainStore()
    const route = useRoute()
    const params = route.params
    if (params.slug === NOT_FOUND_PAGE_SLUG) return app.$error(404)
    const apiUri = params.parent_slug ? `pages/${params.parent_slug}/${params.slug}` : `pages/${params.slug}`
    return store
      .dispatch('apiGet', apiUri)
      .then(async res => {
        const data = res.data
        if (params.parent_slug && (!data.parent_slug || data.parent_slug !== params.parent_slug)) {
          await callWithNuxt(app, async () => await app.$error(404))
        }
        callWithNuxt(app, () =>
          useHeadParams({
            $route: route,
            title: data.title,
            html: data.html,
            headTitle: data.head_title,
            metaDescription: data.meta_description,
            metaKeywords: data.meta_keywords
          })
        )
        return {
          slug: data.slug,
          title: data.title,
          html: data.html,
          headTitle: data.head_title,
          metaDescription: data.meta_description,
          metaKeywords: data.meta_keywords,
          parentSlug: data.parent_slug
        }
      })
      .catch(async e => {
        throw createError({ statusCode: 404, fatal: true })
        // await callWithNuxt(app, async () => await app.$error(404))
      })
  },
  computed: {
    breadcrumbOptions() {
      const options = { title: this.title, path: this.$route.path }
      if (this.parent_slug && this.parent_title) {
        options.parentPath = `/${this.parent_slug}/`
        options.parentTitle = this.parent_title
      }
      return options
    }
  }
}
</script>

<style lang="scss" scoped>
.staticPage {
  &-title {
    padding: 1.6rem 1rem 1rem;
    font-size: 2.2rem;
    font-weight: 700;
    color: $black-1a;
  }
  &-content {
    margin: 0 1rem 1rem 1rem;
  }
}

:deep() {
  @import '/assets/scss/pages.scss';
}

.flexCol {
  flex-direction: column;
}

.breadcrumbsFooter {
  width: 100%;
  margin-top: 3rem;
  margin-bottom: 6rem;
  @include pc {
    margin-top: 3rem;
    margin-bottom: 5rem;
  }
  :deep(.breadcrumbList) {
    box-shadow: 0 0 3px $gray-c6;
  }
}
</style>
